import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import TrafficRaiseCard from '../../components/Metrics/TrafficRaiseCard';
import UsdCard from '../../components/Metrics/UsdCard';
import EurCard from '../../components/Metrics/EurCard';
import QueriesCard from '../../components/Metrics/QueriesCard';
import SuccessCard from '../../components/Metrics/SuccessCard';
import FailedCard from '../../components/Metrics/FailedCard';

const TopGraphs = ({ merchantId }) => (
  <Row>
    <Col xl={12} lg={12} md={12} sm={12} xs={24}>
      <TrafficRaiseCard merchantId={merchantId} />
    </Col>
    <Col xl={6} lg={12} md={12} sm={12} xs={24}>
      <UsdCard merchantId={merchantId} />
    </Col>
    <Col xl={6} lg={12} md={12} sm={12} xs={24}>
      <EurCard merchantId={merchantId} />
    </Col>
    <Col xl={12} lg={12} md={12} sm={12} xs={24}>
      <QueriesCard merchantId={merchantId} />
    </Col>
    <Col xl={6} lg={12} md={12} sm={12} xs={24}>
      <SuccessCard merchantId={merchantId} />
    </Col>
    <Col xl={6} lg={12} md={12} sm={12} xs={24}>
      <FailedCard merchantId={merchantId} />
    </Col>
  </Row>
);
TopGraphs.propTypes = {
  merchantId: PropTypes.string.isRequired,
};

export default TopGraphs;
